export default {
  getRemRole: state => state.remRole,
  getUserPrmsYn: state => state.userPrmsYn,
  getInfraManagerYn: state => state.infraManagerYn,
  getDivisionCd: state => state.divisionCd,
};



// WEBPACK FOOTER //
// ./src/vuex/rem/user/remUserGetters.js